import { createFileRoute } from '@tanstack/react-router';
import { InviteOtp } from '@/pages';

/**
 * OTP verification step of the creator invite sign-up flow.
 * The magic token comes from the parent /invite layout; no personal data is kept in the URL.
 */
export const Route = createFileRoute('/_public/invite/otp')({
  component: InviteOtp,
});
